<template>
  <div class="page-wrapper">
    <b-row class="text-left d-flex">
      <b-col class="mb-3" sm="12" lg="6">
        <!-- Logo + Nome + Versão -->
        <div class="d-flex mb-5">
          <img
            width="50px"
            src="../assets/componente-nfse.png"
            alt="Logo do Componente NFSe"
          />
          <div class="ml-3">
            <span class="titulo">Componente NFSe</span>
          </div>
        </div>

        <!-- Descrição do app -->
        <span class="titulo-section">DESCRIÇÃO</span>
        <p class="descricao mt-3">
          Módulo complementar para download de notas fiscais de Serviço (NFS-e) nas aplicações desktop A1 e A3.
        </p>

        <p>
          Esse módulo permite mais opções de prefeituras para os softwares Klaus A1 e Klaus A3.
        </p>

        <!-- DESCOMENTAR QUANDO HOUVEREM SCREENSHOTS (Não esquecer de alterar os valores do src e do v-pswp das imagens) -->

        <!-- Galeria de screenshots
        <span class="titulo-section">SCREENSHOTS</span>
        <div class="galeria mt-3">
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/robo-klaus-1.png')"
              v-pswp="require('../assets/screenshots/robo-klaus-1.png')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/robo-klaus-2.png')"
              v-pswp="require('../assets/screenshots/robo-klaus-2.png')"
            />
          </Photoswipe>
        </div>  -->
      </b-col>

    </b-row>

    <!-- Modal de download -->
    <modal-download-suite
      @fechar-modal="fecharModal"
      :visibilidade="isModalVisivel"
    />
  </div>
</template>

<script>
import ModalDownloadSuite from "../components/ModalDownloadSuite.vue";
import mixin from "../mixins/mixin";
import "../assets/theme.css";
export default {
  name: "RoboKlaus",
  components: {
    ModalDownloadSuite,
  },
  mixins: [mixin],
};
</script>
